import * as JSONMapper from "json-mapper";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import * as moment from "moment";
import {LocalNumberCountry} from "./local-number-country";

export class LocalNumber extends JSONMapped() {
	@jsonProperty()
	imei: String;

	@jsonProperty()
	localNumberId: String;

	@jsonProperty()
	localNumber: String;

	@jsonProperty()
	iridiumNumber: String;

	@jsonProperty()
	emailAddress: String;

	@jsonProperty(JSONMapper.timestampFromISO)
	startTime: moment.Moment;

	@jsonProperty(JSONMapper.timestampFromISO)
	endTime: moment.Moment;

	@jsonProperty()
	country: LocalNumberCountry;

	constructor(data?: Partial<LocalNumber>) {
		super();
		Object.assign(this, data);
	}
}
